/**
 * Contacts surface (live) - client-side CSV export of the current scope + active
 * filters (item 8). Built from the loaded, filtered roster so the download
 * matches exactly what the user is looking at. Pure client-side, no writes.
 */

import type { Contact } from "./types";

const HEADERS = [
  "Name",
  "Title",
  "Company",
  "Email",
  "Phone",
  "Temperature",
  "Source",
  "Follow-up due",
  "Owner",
  "Notes",
] as const;

function cell(value: string): string {
  return /[",\n\r]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

export function contactsToCsv(rows: Contact[]): string {
  const lines = [HEADERS.join(",")];
  for (const c of rows) {
    lines.push(
      [
        c.name,
        c.title,
        c.company,
        c.email,
        c.phone ?? "",
        c.temperature,
        c.sourceDetail ?? "",
        c.followUpDueAt ?? "",
        c.ownerName,
        c.notes,
      ]
        .map((v) => cell(String(v ?? "")))
        .join(","),
    );
  }
  return lines.join("\r\n");
}

export function downloadContactsCsv(rows: Contact[], scope: string): void {
  if (typeof document === "undefined") return;
  const blob = new Blob([contactsToCsv(rows)], {
    type: "text/csv;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `contacts-${scope}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
